import { connect } from 'react-redux';
import {
  entitySearchAllRequest,
  entitySearchRequest,
  resetOptions,
} from '../../entity-filter/containers/entity-filter-actions';
import EntityFilter from '../components/entity-filter';

const mapStateToProps = state => ({
  options: state.filters.options,
  totalCount: state.filters.totalCount,
  shouldResetAllAdditionalFilterParams: state.worklist.shouldResetAllAdditionalFilterParams,
});

const mapDispatchToProps = {
  performSearch: entitySearchRequest,
  performSearchAll: entitySearchAllRequest,
  resetOptions,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(EntityFilter);
